import React, { useContext, useLayoutEffect, useState } from "react";

const ThemeContext = React.createContext<boolean>(false);

const ThemeUpdateContext = React.createContext<() => void>(() => {});

const DrawerContext = React.createContext<boolean>(true);

const DrawerUpdateContext = React.createContext<() => void>(() => {});

const DrawerWidthContext = React.createContext<number>(240);

const DrawerWidthUpdateContext = React.createContext<(_width: number) => void>(() => {});

export function useThemeContext() {
  return useContext(ThemeContext);
}

export function useThemeUpdate() {
  return useContext(ThemeUpdateContext);
}

export function useDrawerContext() {
  return useContext(DrawerContext);
}

export function useDrawerUpdate() {
  return useContext(DrawerUpdateContext);
}

export function useDrawerWidth() {
  return useContext(DrawerWidthContext);
}

export function useDrawerWidthUpdate() {
  return useContext(DrawerWidthUpdateContext);
}

const NARROW_VIEWPORT_MAX_PX = 768;

function getInitialDrawerOpen(): boolean {
  if (typeof window === "undefined") return true;
  return !window.matchMedia(`(max-width: ${NARROW_VIEWPORT_MAX_PX}px)`).matches;
}

export function ThemeProvider({ children }) {
  const [darkTheme, setDarkTheme] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(getInitialDrawerOpen);
  const [drawerWidth, setDrawerWidth] = useState(240);

  useLayoutEffect(() => {
    const mq = window.matchMedia(`(max-width: ${NARROW_VIEWPORT_MAX_PX}px)`);
    const onViewportChange = () => {
      if (mq.matches) setDrawerOpen(false);
    };
    mq.addEventListener("change", onViewportChange);
    return () => mq.removeEventListener("change", onViewportChange);
  }, []);

  function toggleTheme() {
    setDarkTheme((prevDarkTheme) => !prevDarkTheme);
  }

  function toggleDrawer() {
    setDrawerOpen((prevDrawerOpen) => !prevDrawerOpen);
  }

  return (
    <ThemeContext.Provider value={darkTheme}>
      <ThemeUpdateContext.Provider value={toggleTheme}>
        <DrawerContext.Provider value={drawerOpen}>
          <DrawerUpdateContext.Provider value={toggleDrawer}>
            <DrawerWidthContext.Provider value={drawerWidth}>
              <DrawerWidthUpdateContext.Provider value={setDrawerWidth}>
                {children}
              </DrawerWidthUpdateContext.Provider>
            </DrawerWidthContext.Provider>
          </DrawerUpdateContext.Provider>
        </DrawerContext.Provider>
      </ThemeUpdateContext.Provider>
    </ThemeContext.Provider>
  );
}
